import crypto from 'node:crypto'

import type { EnvSection } from '@core-engine/utils/env.js'
import { appendEnvVars, readEnvVar } from '@core-engine/utils/env.js'
import { detectDevPort } from '@next-adapter/init/scaffolders/dev-server.js'

const LEGACY_DEFAULT_AUTH_URL = 'http://localhost:3000'

function getCoreEnvSections(
  databaseUrl: string | undefined,
  devPort: number,
  namespace: string
): EnvSection[] {
  const authSecret = crypto.randomBytes(32).toString('base64')
  return [
    {
      header: 'Database (PostgreSQL)',
      vars: [{ key: 'DATABASE_URL', value: databaseUrl ?? 'postgresql://...' }]
    },
    {
      header: 'Authentication',
      vars: [
        { key: 'BETTERSTART_AUTH_SECRET', value: authSecret },
        { key: 'BETTERSTART_AUTH_URL', value: `http://localhost:${devPort}` },
        { key: 'BETTERSTART_AUTH_BASE_PATH', value: `/api/${namespace}/auth` }
      ]
    }
  ]
}

function shouldOverwriteAuthUrl(cwd: string, devPort: number): boolean {
  const existingAuthUrl = readEnvVar(cwd, 'BETTERSTART_AUTH_URL')
  if (!existingAuthUrl) return false

  return (
    existingAuthUrl === LEGACY_DEFAULT_AUTH_URL && existingAuthUrl !== `http://localhost:${devPort}`
  )
}

/**
 * Append BETTERSTART_* environment variables to .env.local.
 */
export function scaffoldEnv(
  cwd: string,
  options: { databaseUrl?: string; namespace?: string }
): { added: string[]; skipped: string[]; updated: string[] } {
  const devPort = detectDevPort(cwd)
  const sections = getCoreEnvSections(options.databaseUrl, devPort, options.namespace ?? 'admin')
  const authBasePath = `/api/${options.namespace ?? 'admin'}/auth`
  const overwrite = new Set<string>()
  if (options.databaseUrl) {
    overwrite.add('DATABASE_URL')
  }
  if (shouldOverwriteAuthUrl(cwd, devPort)) {
    overwrite.add('BETTERSTART_AUTH_URL')
  }
  if (readEnvVar(cwd, 'BETTERSTART_AUTH_BASE_PATH') !== authBasePath) {
    overwrite.add('BETTERSTART_AUTH_BASE_PATH')
  }

  return appendEnvVars(cwd, sections, overwrite)
}
